/*
  Relocates the mobile hamburger+cart box (#header-component's
  .header__columns) to the body root, mobile widths only, so it can be
  genuinely `position: fixed` like .gallery-persistent-logo.

  Why this is needed: sections/header.liquid sets `contain: layout style`
  on .header, which per spec makes it the containing block for any
  `position: fixed`/absolute descendant. A fixed-position box left nested
  inside .header only ever resolves its offsets against .header's own
  (scrolling) box, not the viewport — it silently fails to actually stay
  pinned on scroll. The only way around that, short of removing a stock
  performance rule, is moving the node out from under .header entirely,
  same as gallery-persistent-logo.liquid already does for the logo.

  Only .header__columns moves (not the whole header/menu structure), and
  only below the 749px breakpoint used everywhere else in
  assets/gallery-theme.css for this mobile header treatment. Listens for
  matchMedia changes (not just a one-time check on load) because toggling
  between mobile/desktop preview in the Shopify theme editor resizes the
  same iframe without a full page reload — a one-time check would leave
  the node stranded at the body root, no longer fixed, once the viewport
  widened past 749px.
*/
(function () {
  var target = document.querySelector('#header-component .header__row--top .header__columns');
  if (!target) return;

  var originalParent = target.parentElement;
  var originalNextSibling = target.nextElementSibling;
  var mediaQuery = window.matchMedia('(max-width: 749px)');

  function relocate(toBody) {
    if (toBody) {
      if (target.parentElement === document.body) return;
      target.classList.add('gallery-header-actions--fixed');
      document.body.appendChild(target);
    } else {
      if (target.parentElement === originalParent) return;
      target.classList.remove('gallery-header-actions--fixed');
      if (originalNextSibling && originalNextSibling.parentElement === originalParent) {
        originalParent.insertBefore(target, originalNextSibling);
      } else {
        originalParent.appendChild(target);
      }
    }
  }

  relocate(mediaQuery.matches);

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', function (event) {
      relocate(event.matches);
    });
  } else if (mediaQuery.addListener) {
    // Safari < 14
    mediaQuery.addListener(function (event) {
      relocate(event.matches);
    });
  }
})();
